<template>
    <a-spin :tip="loadingTip" :spinning="isloading">
        <div>
            <div class>
                <a-form :form="form" @submit="handleSubmit">
                    <a-form-item label="注册地区" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                        <a-switch
                                v-model="info.isArea"
                                checkedChildren="是"
                                unCheckedChildren="否"
                                v-decorator="[
          'isArea',
          {rules: []}
        ]"
                        />
                    </a-form-item>
                    <a-form-item  v-if="info.isArea" label="选择地区" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
                        <a-select
                                v-model="info.selectAreaList"
                                :default-value="info.selectAreaList"
                                mode="multiple"
                                style="width: 100%"
                                :filter-option="filterArea"
                                placeholder="选择地区/不选默认全部"
                                @change="handleChange"
                        >
                            <a-select-option
                                    :value="info.name"
                                    v-for="(info, index) in info.areaList"
                                    :key="index"
                            >{{info.name}}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="主管部门" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                        <a-switch
                                v-model="info.isAdmin"
                                checkedChildren="是"
                                unCheckedChildren="否"
                                v-decorator="[
          'isAdmin',
          {rules: []}
        ]"
                        />
                    </a-form-item>
                    <a-form-item v-if="info.isAdmin" label="选择主管部门" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
                        <a-select
                                v-model="info.selectAdministrationList"
                                :default-value="info.selectAdministrationList"
                                mode="multiple"
                                style="width: 100%"
                                :filter-option="filterAdmininstor"
                                placeholder="选择主管部门/不选默认全部"
                                @change="handleChange"
                        >
                            <a-select-option
                                    :value="info.itemName"
                                    v-for="(info, index) in info.administrationList"
                                    :key="index"
                            >{{info.itemName}}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="企业" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                        <a-switch
                                v-model="info.isEnter"
                                checkedChildren="是"
                                unCheckedChildren="否"
                                v-decorator="[
          'isEnter',
          {rules: []}
        ]"
                        />
                    </a-form-item>
                    <a-form-item v-if="info.isEnter" label="选择企业" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
                        <a-select
                                v-model="info.selectEnterpriseList"
                                :default-value="info.selectEnterpriseList"
                                mode="multiple"
                                :filter-option="filterEnpertrise"
                                style="width: 100%"
                                placeholder="选择企业/不选默认全部"
                                @change="handleChange"
                        >
                            <a-select-option
                                    :value="info.id"
                                    v-for="(info, index) in info.enterpriseList"
                                    :key="index"
                            >{{info.name}}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item :wrapper-col="{ span: 19, offset: 4 }">
                        <pxkeji-btn name="保存" type="primary" htmlType="submit"/>
                        <pxkeji-btn name="取消" type="default" @click="cancelClick" class="cancelBtn"/>
                    </a-form-item>
                </a-form>
            </div>
        </div>
    </a-spin>
</template>

<script>
    var that;


    export default {
        props: {
            id:String
        },
        data() {
            return {
                form: this.$form.createForm(this),
                info: {
                    selectAreaList: [],
                    areaList: [],
                    selectAdministrationList: [],
                    administrationList: [],
                    selectEnterpriseList: [],
                    defaulteList:[],
                    enterpriseList: [],
                    isAdmin:false,
                    isArea:false,
                    isEnter:false,
                },
                isloading: false,
                loadingTip: "加载中...",
                //富文本


            };
        },
        components: {},
        mounted() {
            this.$nextTick(function () {
                that = this;
                this.getArea();
                this.getAdmininstor();
                this.getEnterprise();
                if (this.id != 0) {
                    //编辑
                    this.getInfo();
                }
            });
        },
        methods: {
            handleChange(v) {

            },
            filterArea(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            filterAdmininstor(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            filterEnpertrise(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            /**取消 */
            cancelClick() {
                this.$emit("callbackMethod");
            },
            getAdmininstor() {
                this.$api.dictionaryItem.getDictionaryItem(23).then((res) => {
                    this.isloading = false;
                    if (res.errorCode == this.$msg.responseCode.success) {
                        this.info.administrationList = res.data;
                    } else {
                        this.error(res.errorMsg);
                    }
                })
                    .catch(() => {
                        this.isloading = false;
                    });


            },
            getEnterprise() {
                this.$api.enterprise.getAll().then((res) => {
                    this.isloading = false;
                    if (res.errorCode == this.$msg.responseCode.success) {
                        this.info.enterpriseList = res.data;
                    } else {
                        this.error(res.errorMsg);
                    }
                })
                    .catch(() => {
                        this.isloading = false;
                    });
            },
            getArea() {
                var city = this.$api.city.city;
                for (let x of city) {
                    if (x.name == "河北省") {
                        this.info.areaList = x.children;
                    }
                }
            },
            /**获取详情 */
            getInfo() {
                this.isloading = true;
                this.$api.course
                    .getById(this.id)
                    .then((res) => {
                        this.isloading = false;
                        if (res.errorCode == this.$msg.responseCode.success) {
                            this.info.selectAreaList=res.data.city.split(',');
                            this.info.selectAdministrationList=res.data.administration.split(',');
                            this.info.selectEnterpriseList=res.data.enterprise.split(',');

                        } else {
                            this.error(res.errorMsg);
                        }
                    })
                    .catch(() => {
                        this.isloading = false;
                    });
            },
            handleSubmit(e) {
                e.preventDefault();

                this.form.validateFields((err, values) => {
                    if(this.info.selectAdministrationList.length==0){
                        for (let i = 0; i <this.info.administrationList.length ; i++) {
                            this.info.selectAdministrationList.push(this.info.administrationList[i].itemName)
                        }
                    }
                    if(this.info.selectAreaList.length==0){
                                   var item =this.info.areaList;
                        for (let i = 0; i <item.length ; i++) {
                            this.info.selectAreaList.push(item[i].name)
                        }
                    }
                    if(this.info.selectEnterpriseList.length==0){
                        var infoitem =this.info.enterpriseList;
                        for (let i = 0; i <infoitem.length ; i++) {
                            this.info.selectEnterpriseList.push(infoitem[i].id)
                        }
                    }
                    this.$emit("callbackMethod", this.info.selectAdministrationList.join(","),this.info.selectAreaList.join(","),this.info.selectEnterpriseList.join(","));
                });
            },
            error(msg) {
                this.$error({
                    title: "提示",
                    content: msg == undefined ? "服务器异常" : msg,
                    okText: "返回",
                    centered: true,
                    onOk() {
                        that.$emit("callbackMethod");
                    },
                });
            },
        },
    };
</script>
<style>
</style>